import type {ProductData} from "~/models/ProductData";

import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

export class SalesHelper {
  private constructor(private product: ProductData | null) {}

  public static of(product: ProductData | ProductDescriptor | undefined | null): SalesHelper {
    if (!product) {
      return new SalesHelper(null);
    }
    const data = "base" in product ? product.base : product;
    return new SalesHelper(data);
  }

  isProductOnSale() {
    if (!this.product) {
      return false;
    }
    return Object.values(this.product.salesCampaign ?? {}).length > 0;
  }

  isPackageOnSale(packCode?: string) {
    if (!this.product || !packCode) {
      return false;
    }
    return this.product.salesCampaign?.[packCode]?.length > 0;
  }
}
